import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({ baseURL: API_BASE });

/* Délai maximal des appels du parcours passager (inscription, grattage).
   Axios n'impose aucun délai par défaut : une réponse qui n'arrive jamais
   laissait le bouton « Inscription… » tourner sans fin, sans message ni moyen
   de réessayer. À poser sur ces appels-là seulement — les téléversements et
   l'export ZIP de la console doivent, eux, pouvoir durer. */
export const PASSENGER_TIMEOUT_MS = 30_000;

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("gocab_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      sessionStorage.removeItem("gocab_token");
      sessionStorage.removeItem("gocab_user");
      const p = window.location.pathname;
      // Session expirée : chacun retourne à SA porte. Renvoyer un annonceur sur
      // la console ops le laisserait devant un formulaire qui refuse désormais
      // son compte. Chemins en dur : lib/auth.jsx importe déjà ce module, les
      // constantes y vivent (ADMIN_LOGIN_PATH / PARTNER_LOGIN_PATH).
      if (p.startsWith("/portal")) {
        window.location.href = "/portal/login";
      } else if (p.startsWith("/admin")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatErr = (e) => {
  // Délai dépassé : le message d'axios est technique et en anglais.
  if (e?.code === "ECONNABORTED" || e?.code === "ETIMEDOUT") {
    return "Le serveur met trop de temps à répondre — vérifiez votre connexion et réessayez.";
  }
  const d = e?.response?.data?.detail ?? e?.message;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  if (typeof d === "string") return d;
  return "Erreur inattendue";
};
